const PROD = "prod";
const DEMO = "demo";
const DEV = "dev";

export const activeProfile = PROD;

export const LANGUAGES = [
  { label: "English", code: "en" },
  { label: "Hindi", code: "hi" }
];

export const headers = {
  'Content-Type': 'application/json',
};

export const apiTimeOutInMilli = 1800000;
export const maxRedirects = 10;

export const feedbackStatus = [{ 'id': 'All', 'desc': 'All' }, { 'id': 'A', 'desc': 'Work In Progress' }, { 'id': 'R', 'desc': 'Resolved' }, { 'id': 'O', 'desc': 'Reopened' }, { 'id': 'C', 'desc': 'Closed' }];
export const feedbackStatusSPOC = [{ 'id': 'All', 'desc': 'All' }, { 'id': 'N', 'desc': 'New' }, { 'id': 'SA', 'desc': 'Assigned' }, { 'id': 'A', 'desc': 'Accepted' }, { 'id': 'R', 'desc': 'Resolved' }, { 'id': 'O', 'desc': 'Reopened' }, { 'id': 'C', 'desc': 'Closed' }];
export const feedbackStatusResolver = [{ 'id': 'All', 'desc': 'All' }, { 'id': 'N', 'desc': 'Assigned' }, { 'id': 'A', 'desc': 'Accepted' }, { 'id': 'R', 'desc': 'Resolved' }, { 'id': 'O', 'desc': 'Reopened' }, { 'id': 'C', 'desc': 'Closed' }];
export const feedbackStatusCST =
  [{ 'id': 'All', 'desc': 'All' }, { 'id': 'N', 'desc': 'Assigned' }, { 'id': 'A', 'desc': 'OPEN' }, { 'id': 'R', 'desc': 'OPEN with CS team' }, { 'id': 'O', 'desc': 'REOPENED & NOT ASSIGNED' }, { 'id': 'OR', 'desc': 'REOPENED with CS Team' }, { 'id': 'OA', 'desc': 'REOPENED' }, { 'id': 'C', 'desc': 'CLOSED' }, { 'id': 'CC', 'desc': 'CLOSED by CS Team' }, { 'id': 'CCC', 'desc': 'CLOSED by Customer' }, { 'id': 'OC', 'desc': 'REOPENED & CLOSED by CS Team' }, { 'id': 'OCC', 'desc': 'REOPENED & CLOSED by Customer' },];
export const customerRoleIds = [107, 108]
export const botReplyFailedMessagesList = ['We apologize','@mjunction', 'Sorry', 'sorry', '922268', 'I don\'t know', 'apologize','I cannot provide an answer to your question','please contact','apologies']

export const primary_theme_color = "#33cce0";
export const secondary_theme_color = "#0e6e7b";
export const light_theme_off_white = "#F1ECEC";
export const light_theme_solid_blue = "#0a7ad1";
export const light_theme_black = "#000000";
export const light_theme_bg_grey = "#6A81AC";

export const primaryAppDate = 'DD-MM-yyyy';
export const datePickerAppDate = 'DD-MM-YYYY';
export const MISReportDateFormat = 'YYYY-MM-DD';
export const primaryAppTimeFormat = 'hh:mm A';
export const primaryAppDateTimeFormat = 'DD-MM-yyyy hh:mm A';

export const CallbackReportDateFormat = 'YYYY-MM-DD';

export const skeleton_animation_style_primary = "wave";
export const to_do_character_count = 50;
export const dashboard_feedback_discription_length = 20;
export const manageMyHistoryFeedbackLength = 10000;

export const maxFileUploadSizeInByte = 12582912;
export const fileUploadAllowedExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".zip", ".rar", ".xml", ".xps", ".msg", ".eml"];
export const fileUploadAllowedMimeTypes = ["image/png", "image/gif", "image/bmp", "image/jpeg"];

export const showRoleSwitchToCustomer = true;
export const applicationContextRoot = '/mj-care';
export const minInputValueForClientField = 3;

export const chatbox_chat_type_agent = 'AGENT';
export const chatbox_chat_type_bot = 'BOT';
export const chatbox_chat_type_user = 'USER';
export const chatbox_typewriter_speed = 30;

export const isInterceptorActive = true;
export const maxRetryCount = 3

let chatbox_agent_chat_queue_key = 'Customer_key'
let needCaptchaEnabled = false;
let apiUrl = "";
let webSocketUrl = "";

if (activeProfile == DEV) {
  needCaptchaEnabled = false;
  apiUrl = "http://localhost:8082/cchp-api";
  webSocketUrl = "http://localhost:8082/cchp-api/ws/";
  chatbox_agent_chat_queue_key = 'demo_' + 'chatuserqueue_'
} else if (activeProfile == DEMO) {
  needCaptchaEnabled = false;
  apiUrl = "https://demofeedback.mjunction.in/cchp-api";
  webSocketUrl = "https://demofeedback.mjunction.in/cchp-api/ws/"
  chatbox_agent_chat_queue_key = 'demo_' + 'chatuserqueue_'
  
} else if (activeProfile == PROD) {
  needCaptchaEnabled = true;
  apiUrl = "https://feedback.mjunction.in/cchp-api";
  //apiUrl = "http://localhost:8082/cchp-api";
  webSocketUrl = "https://feedback.mjunction.in/cchp-api/ws/"
  //webSocketUrl = "http://localhost:8082/cchp-api/ws/";
  chatbox_agent_chat_queue_key = 'prod_' + 'chatuserqueue_'

}

export const isCaptchaEnabled = needCaptchaEnabled;
export const checkOnlineStatusinterval=600000;

//Main api host url
export const apiHostUrl = apiUrl;
export const wsHostUrl = webSocketUrl;
export const chatbox_agent_chat_queue_key_prefix = chatbox_agent_chat_queue_key;
//Backend urls
export const loginUrl = apiHostUrl + "/login";
export const logoutUrl = apiHostUrl + "/logout";
export const getCSRFUrl = apiHostUrl + "/get-csrf";
export const getLoginInfoUrl = apiHostUrl + "/get-login-info";
export const handleSessionUrl = apiHostUrl + "/handle-multi-session";
export const setLanguageUrl = apiHostUrl + "/home";
export const changeRoleUrl = apiHostUrl + "/logged-in-user/change-auth";
export const getProcessConditionURL = "/receipt/get-process-condition";
export const getCaptchaWOTimeUrl = apiHostUrl + "/get-captcha/";
export const ResetPasswordUrl = apiHostUrl + "/reset-password";
export const getUserData = "/feedback/getUserData";
export const getCustomerOldFeedbackList = apiHostUrl + "/customer/feedback/getOldFeedbackList";
export const getFeedbackTypeList = apiHostUrl + "/spoc/feedback/getFeedbackTypeList";
export const getFeedbackTypeListAll = "/feedback/getFeedbackTypeList";
export const getCustomerDepartmentAttributeMap = "/feedback/getDepartmentAtributeMap";
export const getAllDepartmentAttributeMap = "/feedback/getDepartmentAtributeMap";
export const getDepartmentAtributeMap = apiHostUrl + "/spoc/feedback/getDepartmentAtributeMap";
export const viewFeedbackCSTUrl = apiHostUrl + "/cst/feedback/view-feedback";
export const getFeedbackSourceList = apiHostUrl + "/spoc/feedback/get-feedback-source-list";
export const getFeedbackSource = "/feedback/get-feedback-source-list";
export const viewFeedbackINTERNALUrl = "/feedback/view-internal-feedback";
export const viewFeedbackCUSTOMERUrl = apiHostUrl + "/customer/feedback/view-customer-feedback";
export const getCustomerFeedbackTypeListByDepartment = apiHostUrl + "/customer/master/get-feedbacktype-by-departemnt/"
export const addFeedbackCustomerUrl = apiHostUrl + "/customer/feedback/addFeedbackData";
export const addFeedbackUrl = "/feedback/addFeedbackData";
export const addCustomerResponseUrl = "/feedback/addCustomerResponse";
export const getInternalFeedbackDetailsURL = apiHostUrl + "/internal/feedback/get-feedback-details";
export const getCstFeedbackDetailsURL = "/feedback/get-feedback-details";
export const getFeedbackDetailsURL = "/feedback/get-feedback-details";
export const getCustomerFeedbackDetailsURL = apiHostUrl + "/customer/feedback/get-feedback-details";
export const getSPOCFeedbackDetailsURL = apiHostUrl + "/spoc/feedback/get-feedback-details";
export const addFeedbackSpocUrl = apiHostUrl + "/spoc/feedback/addFeedbackData";

export const uploadFeedbackAttachmentInternal = apiHostUrl + "/internal/feedback/uploadFeedbackAttachment";
export const uploadFeedbackAttachmentSpoc = apiHostUrl + "/spoc/feedback/uploadFeedbackAttachment";
export const uploadFeedbackAttachmentCustomer = apiHostUrl + "/customer/feedback/uploadFeedbackAttachment";
export const getOldFeedbackSPOCUrl = "/feedback/getOldFeedbackList";
export const closeFeedbackCSTURL = apiHostUrl + "/cst/feedback/add-multiple-feedback-satisfaction";
export const closeFeedbackSPOCUrl = "/feedback/assigned-feedback-list";
export const customerSatisfactionCustomerURL = apiHostUrl + "/customer/feedback/add-feedback-satisfaction";
export const addSatisfactionURL = "/feedback/add-feedback-satisfaction";
export const acceptFeedbackSPOCURL = "/feedback/assigned-feedback-list";
export const getFeedbackDetailsforFeedbackCloseURL = "/feedback/getFeedbackDetailsforFeedbackClose";
export const calculateSLAtimeURL = apiHostUrl + "/spoc/receipt/reCalculateSLATime";
export const calculateSLATimeURL = "/receipt/reCalculateSLATime";
export const acceptFeedbackAfterOnClickURL = apiHostUrl + "/spoc/feedback/acceptFeedback";
export const acceptFeedbackURL = "/feedback/acceptFeedback";

export const getUserListfromGroupName = "/user/getUserListfromGroupName";
export const closeFeedbackSPOC = apiHostUrl + "/spoc/feedback/closeFeedback";
export const feedbackBulkResolveList = "/feedback/get-bulk-resolve";
export const resolveBulkFeedback = "/feedback/resolve-bulk-feedback";
export const closeFeedbackURL = "/feedback/closeFeedback";
export const homeUrl = applicationContextRoot + "/home";
export const uploadFeedbackAttachment = "/feedback/upload-file";
export const satisfactionDetails = "";
export const feedbackBulkCloseList = "/feedback/get-bulk-close-feedback";
export const closeBulkFeedback = "/feedback/close-bulk-feedback";
//dashboard urls
export const dashboradData = "/dashboard/get-dashboard-data-spoc";
export const dashboradDataResolver = "/dashboard/get-resolver-dashboard";
export const dashboardInternal = "/dashboard/get-internal-dashboard";
export const dashboardCst = "/dashboard/get-csteam-data";
export const dashboardCustomer = "/dashboard/get-customer-dashboard";
export const dashboardBuh = "/dashboard/get-dashboard-data-buh";
export const dashboardClient = "/dashboard/get-dashboard-data-client";
export const dashboardEmu = "/dashboard/get-dashboard-data-emu";
export const dashboardCstOnKPIClick = "/dashboard/get-csteam-data";
export const dashboardResolverKPIClick = "/dashboard/get-resolver-frontbox-feedback-list";

export const getconsentuserURL = "/feedback/get-consent-user";
export const addUserURL = "/user/add-customer-user";
export const addUsercstURL = "/user/add-user";
export const addUserSpocExternalURL = "/user/add-internal-user";

export const getUserType = "/user/get-usertype-by-department";
export const getAreaByFeedbackTypeURL = "/master/get-area-by-feedbacktype"
export const getSubAreaURL = "/receipt/getSubAreaforArea"
export const getSLADetailsURL = "/receipt/getSLADetails"
export const getPriorityforSubArea = "/receipt/getPriorityforSubArea";
export const newFeedbackListSPOCUrl = apiHostUrl + "/spoc/feedback/new-feedback-list"
export const getDepartmentAtributeMapSPOC = apiHostUrl + "/spoc/feedback/getDepartmentAtributeMap";
export const getDepartmentAtributeMapAll = "/feedback/getDepartmentAtributeMap";
export const getDetailsforReceiptSPOCURL = apiHostUrl + "/spoc/receipt/getDetailsforReceipt"
export const saveFeedbackDetailsSPOC = apiHostUrl + "/spoc/feedback/save-department-atributes"
export const tagOldFeedbackReceipt = "/receipt/feedback-tag"
export const unTagOldFeedbackReceipt = "/receipt/feedback-untag"
export const reCalculateSLATimeURL = "/receipt/reCalculateSLATime"
export const quickLogIssueSPOCURL = "/feedback/get-department-quickissue";
export const searchCustomerDetailsEndPoint = "/feedback/search-customer-details";
export const getClientsSPOCURL = "/feedback/get-clients";
export const quickIssueSubarrySPOCURL = "/master/get-quickissue-subarea";
export const quickIssueSubmitUrl = "/feedback/add-quick-issues";
export const addReceiptURL = "/receipt/addReceipt"
export const closeFeedbackFromAddReceiptURL = "/receipt/receiptAddClose"
export const defineAuthorizationURL = "/user/define-authorization"
export const getAuthorization = "/user/get-authorization"
export const saveAuthorization = "/user/save-authorization"
export const departList = "/user/get-department-list"
export const userAssignGetList = "/feedback/assigneeGroup/getList"
export const getDetailsAssigneeGroup = "/feedback/assigneeGroup/getGroupUserList";
export const removeAssigneeGroup = "/feedback/assigneeGroup/removeUser";
export const departmentwiseAssignGrpURL = "/user/departmentwise";
export const addAssigneeUserURL = "/feedback/assigneeGroup/addAssigneeUser";
export const getAssigneeGroupTypeListURL = "/feedback/assigneeGroup/getGroupTypeList";
export const addAssigneeGroupURL = "/feedback/assigneeGroup/add";
export const getSlaConditionByDepartmentEscURL = "/master/get-sla-condition-by-department";
export const getFeedbacktypeByDepartment = "/master/get-feedbacktype-by-department";
export const getClientByDepartment = "/master/get-client-by-department";
export const getEscalationMatrix = "/feedback/get-escalation-matrix";
export const getEscalationDetailsURL = "/feedback/get-escalation-details";
export const getEscalationDetailsURLBulk = "/feedback/get-escalation-details-bulk";
export const getUserListfromGroupNameURL = "/user/getUserListfromGroupName";
export const editEscalationMatrix = "/feedback/edit-escalation-matrix";
export const editEscalationMatrixBulk = "/feedback/edit-escalation-matrix-bulk";
export const downloadEscalationMatrix = "/feedback/download-escalation-matrix";
export const downloadEscalationMatrixTemplate = "/feedback/download-escalation-matrix-template";
export const previewEscalationMatrixUpload = "/feedback/upload-escalation-matrix/preview";
export const confirmEscalationMatrixUpload = "/feedback/upload-escalation-matrix/confirm";
export const updateSlaEscalationMatrix = "/feedback/update-sla";
export const updateSlaEscalationMatrixBulk = "/feedback/update-sla-bulk";
export const updateEscalationMatrix = "/feedback/update-escalation";
export const updateEscalationMatrixBulk = "/feedback/update-escalation-bulk";
export const resetUserPassword = "/user/reset-user-password";
export const searchFeedbackURL = "/feedback/search-feedback";
export const discardFeedbackURL = "/feedback/delete-feedback";
export const passwordreserUrl = "/user/reset-user-password";
export const getFeedbackDescriptionTemplate = "/feedback/get-feedback-description-template"
export const addComment = '/feedback/add-comment';
// export const fileDownloadUrl='/feedback/download';
export const getAreaResponseLogger = "/feedback/get-area-responselogger"
export const responseToLoggerTemplate = "/feedback/get-responsetemplate"
export const fileDownloadUrl = '/feedback/download';
export const updateConsent = '/feedback/update-consent';
export const getSurveybyId = '/survey/launch-survey-api';
export const getSurveybyDepartmentSRVCUser = '/survey/get-survey-api';
export const getSurveybyEncryptedData = '/survey/start-survey-api';
export const feedbackTypeURL = '/master/get-feedbacktype-by-department';
export const viewSurveyListURL = '/survey/view-survey-list';
export const fetchToDoListURL = '/get-todos';
export const saveToDoListURL = '/save-todo';
export const viewSurveyDetail = '/survey/view-survey-detail';
export const doReassignFeedbackURL = '/feedback/do-reassign-feedback';
export const viewSurveySubmitDetail = '/survey/view-surveySubmit-detail/';
export const getConsentListURL = '/dashboard/get-consent-list';
export const getSatisfactionListURL = '/feedback/get-satisfaction-details';
export const submitSurveyResponse = '/survey/submit-survey-response';
export const surveyFormDownload = '/survey/download-survey-details';
export const surveyAddForm = '/survey/add-customer-survey';
export const getUserlistfromGroupName = '/user/getUserListfromGroupName';

//Analytic dashboard urls
export const getComplaintFeedbackCountDataURL = '/analytic/dashboard/get-complaint-feedback-count-data';
export const getComplaintFeedbackStatusDataURL = '/analytic/dashboard/get-complaint-feedback-status-chart';
export const getOverallReviewStatusDataURL = '/analytic/dashboard/get-overall-complaint-review-data';
export const addCustomerFeedback = "/prospective/add-customer-feedback-api";
export const checkEmail = "/prospective/check-email";
export const checkMobile = "/prospective/check-mobile";
export const getDepartmentAtribute = "/prospective/getDepartmentAtributeMap";
export const addProspectiveBuyerFeedback = "/prospective/add-prospective-buyer-feedback";
export const getFeedbackPriorityList = "/feedback/get-feedback-priority-master-list";
export const updateFeedbackPriorityURL = "/update-feedback-priority";
export const getSubQuestion = "/survey/get-sub-question";
// export const updateFeedbackPriorityURL = "/update-feedback-priority";
export const getInternalDepartment = "/feedback/get-department-list";
export const regenarateOtpForMfa = "/mfa/regenrate-mfa";
export const submitOtpForMfa = "/mfa/submit-mfa";
export const getFAQListUrl = "/feedback/get-faq-list";
export const sendMailUrl = "/feedback/add-send-service-mail";

export const callbackReportUrl = "/chatbot/get-callback-report";
export const callbackRequestSendUrl = "/send-callback-request";
export const callbackRequestFetchAllUrl = "/agent/fetch-callback-requests";
export const callbackCommentResponseSaveUrl = "/save-callback-comment-response";
export const fetchActiveCallbackRequestsById = "/fetch-active-callback-request-by-userId";
export const commentresponseCountLimit = 2;
export const SESSION_CHECK_INTERVAL = 1800 * 1000;
export const WAITING_TIME_SESSION = 2 * 1000;
export const chatBoxUserWSSendPrefix_BOT = '/bot-message';
export const chatBoxUserWSSendPrefix_AGENT = '/agent-message';
export const chatBoxUserWSSendPrefix_USER =  '/user-message';
export const chatBoxUserWSTypingPrefix_USER =  '/user-typing';
export const chatBoxUserWSTypingPrefix_AGENT =  '/agent-typing';
export const customerInactiveAlertTime= 120000;
export const vj2DeptId = "342";
export const getResponseDetailsUrl="/feedback/getResponseDetailsUrl";
export const getAreaOfConcernReportUrl="/reports/business-reoprts/areaOfConcernReport";
export const generateNewAreaOfConcernReport="/reports/business-reoprts/generateNewAreaOfConcernReport";
export const getareaOfConcernReportDetailsUrl="/reports/business-reoprts/areaOfConcernReportDetails";
export const getAreaOfConcernGenerateReportData="/reports/business-reoprts/areaOfConcernGenerateReportData";
export const updateAreaOfConcernReportUrl="/reports/business-reoprts/areaOfConcernUpdateReportData";
export const generateAreaOfConcernReportExcel="/reports/business-reoprts/generateAreaOfConcernReport";
export const misRawDumpMultiDeptUrl = "/reports/business-reoprts/mis-raw-dump-multi-dept";
export const getDepartmentAttribute="/reports/business-reoprts/getDepartmentAttribute";
export const reportMenus = [
  { id: "aging||FYear||timeFrame||fromDateToDate||aging", description: "Ageing Report" },
  { id: "assignmentPercent||FYear||multiStatus||visualization||fromDateToDate", description: "Assignment SLA %" },
  { id: "misRawDump||fromDateToDate", description: "MIS Raw Dump" },
  { id: "pickupSla||FYear||multiStatus||visualization||fromDateToDate", description: "Pickup SLA %" },
  { id: "repeatReason||FYear||months||fromDateToDate", description: "Repeat Reasons" },
  { id: "repeatPercent||FYear||visualization||fromDateToDate||months", description: "Repeat %" },
  { id: "slaPercent||FYear||multiStatus||visualization||fromDateToDate", description: "SLA %" },  
  { id: "statusCount||FYear||months||fromDateToDate||status||feedback||percentage", description:"Status"},
  { id: "misRawDumpMultiDept||fromDateToDate||multiDept", description: "Resolved MIS" },
//  { id: "topReason||", description: "Top Reasons" }  
];

export const getReportTypeList= "/reports/business-reoprts/getReportTypeList";
export const updateFeedbackUserURL = "/feedback/updateFeedbackUser";